const Gif = ({ src }) => {
  return (
    <video autoPlay loop muted playsInline className="reference">
      <source src={src} type="video/webm" />
    </video>
  );
};

export default Gif;
